import actions from "./actions";

const initState = {
  items: [],
  loading: false,
  total: 0.0,
};

export default function salesInfoReducer(
  state = initState,
  { type, ...action }
) {
  switch (type) {
    case actions.GET_ITEMS_SALES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case actions.GET_ITEMS_SALES_SUCCESS:
      let totalSum = 0;
      action.items.forEach((element) => {
        totalSum += element.sum;
      });
      return {
        ...state,
        items: action.items,
        loading: false,
        total: totalSum,
      };

    default:
      return state;
  }
}
